import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function Areas() {
  return (
    <>
      <Navbar />
        <div>Areas</div>
      <Footer />
    </>

  )
}

export default Areas